import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Image } from '../AbstractElements';

// Shared logo/card wrapper used by every public auth page (login, forgot
// password, reset password, magic-link landing) so they look like one system.
const AuthShell = ({ children }) => {
  return (
    <Container fluid={true} className="p-0">
      <Row className='m-0'>
        <Col xs="12" className='p-0'>
          <div className="login-card auth-login">
            <div>
              <div className='logo'>
                <Image attrImage={{ className: 'img-fluid for-light custom-logo', src: `${require('../assets/images/logo/logo.png')}`, alt: 'logo image', style: { maxWidth: '250px' } }} />
              </div>
              <div className="login-main login-tab">
                {children}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthShell;
